import styled from "styled-components";

const TableTitle = styled.h5`
  padding: 0;
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #141f2d;
  font-family: "Kumbh Sans";
`;

export default TableTitle;
